<template>
    <div class="checkout">
        <div id="hero" style="background-image:url(https://staging.vadobay.com/assets/sliderHome/1-welfare-aziendale.jpeg)"></div>
        <div class="content">
            <b-container v-if="submitted">
                <div class="checkout--sent">
                    <div class="checkout--sent--title">
                        {{ submitted_msg }}
                    </div>
                    <div class="checkout--sent--subtitle">
                        <p>
                            il tuo codice di conferma è: <b>{{ submitted_confirm_code }}</b>
                            <!--<br>il tuo travel id è: <b>{{ submitted_travel_voucher_id }}</b>-->
                        </p>
                    </div>
                    <!--<p>
                        <b-button variant="light" @click="goto_confirm">Vai alla tua prenotazione</b-button>
                    </p>-->
                    <!--
                    <p>
                        <b-button variant="light" @click="router.push('/homepage')">Torna alla home</b-button>
                    </p>-->
                </div>  
            </b-container>
            <b-container v-if="!submitted">
                <b-row>
                    <b-col cols="8">
                        <h1>
                            {{ travel.quote.details.title }}
                        </h1>
                        <div class="detail--services">
                            <div class="detail--service" v-for="(service,index) in travel.quote.services" v-bind:key="index">
                                <detail-overnight
                                    v-if="service.type == 'overnight'"
                                    :travel="travel"
                                />
                                <detail-package
                                    v-if="service.type == 'package'"
                                    :travel="travel"
                                />
                                <detail-flight
                                    v-if="service.type == 'flight'"
                                    :travel="travel"
                                />
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="4">
                        <div class="sidebar-checkout">
                            <div class="panel">
                                <div class="sidebar-checkout--header">
                                    <div class="sidebar-checkout--header--avatar">
                                        <img :src="integration.avatarSrc" />
                                    </div>
                                    <div class="sidebar-checkout--header--name">
                                        {{ integration.displayName }}
                                    </div>
                                    <div class="sidebar-checkout--header--availability">
                                        € {{ integration.availability }}
                                    </div>
                                </div>
                                <hr class="panel--separator fullwidth" />
                                <div class="sidebar-checkout--resume">
                                    <div class="sidebar-checkout--title">
                                        Riepilogo
                                    </div>
                                    <p>
                                        <b>{{travel.productCode}} - {{ travel.title }}</b>
                                    </p>
                                    <ul>
                                        <div v-for="(service,index) in travel.quote.services" v-bind:key="index">
                                            <li v-if="service.type == 'flight' | service.type == 'overnight'">
                                                {{ service.details.title }}
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                                <hr class="panel--separator fullwidth" />
                                <div class="sidebar-checkout--resume">
                                    <div class="sidebar-checkout--resume--total">
                                        € {{ travel.quote.details.grand_total }}
                                    </div>
                                </div>
                            </div>

                            <!--
                            TODO: credito insufficiente?
                            <b-alert show variant="danger" v-if="parseFloat(integration.availability) < parseFloat(travel.public_price)">
                                Credito insufficiente!
                            </b-alert>

                            <div class="panel" v-else>
                            -->

                            <div class="panel">
                                <div class="sidebar-checkout--fields">
                                    <div class="sidebar-checkout--title">
                                        Conferma della prenotazione
                                    </div>
                                    <b-form-group :state="validate()">
                                        <b-form-group id="request-customer-firstname" label="Nome *" label-for="request-customer-firstname">
                                            <b-form-input
                                                ref="request-customer-firstname"
                                                id="request-customer-firstname"
                                                v-model="firstname"
                                                type="text"
                                                placeholder="Nome"
                                                required
                                            ></b-form-input>
                                            <div class="formerror"></div>
                                        </b-form-group>
                                        <b-form-group id="request-customer-lastname" label="Cognome *" label-for="request-customer-lastname">
                                            <b-form-input
                                                ref="request-customer-lastname"
                                                id="request-customer-lastname"
                                                v-model="lastname"
                                                type="text"
                                                placeholder="Cognome"
                                                required
                                            ></b-form-input>
                                            <div class="formerror"></div>
                                        </b-form-group>
                                        <b-form-group id="request-customer-email" label="Email *" label-for="request-customer-email">
                                            <b-form-input
                                                ref="request-customer-email"
                                                id="request-customer-email"
                                                v-model="email"
                                                type="email"
                                                placeholder="Email"
                                                required
                                            ></b-form-input>
                                            <div class="formerror"></div>
                                        </b-form-group>
                                        <b-form-group id="request-customer-email-confirm" label="Ripeti email *" label-for="request-customer-email-confirm">
                                            <b-form-input
                                                ref="request-customer-email-confirm"
                                                id="request-customer-email-confirm"
                                                v-model="email_confirm"
                                                type="text"
                                                placeholder="Ripeti email"
                                                required
                                            ></b-form-input>
                                            <div class="formerror"></div>
                                        </b-form-group>
                                        <b-form-group id="request-customer-repeat-phone" label="Numero di cellulare *" label-for="request-customer-phone">
                                            <b-form-input
                                                ref="request-customer-phone"
                                                id="request-customer-phone"
                                                v-model="phone"
                                                type="text"
                                                placeholder="+39 ..."
                                                required
                                            ></b-form-input>
                                            <div class="formerror"></div>
                                        </b-form-group>
                                        <div class="privacy-box">
                                            <b-form-checkbox v-model="privacy" ref="checkbox-privacy" required type="checkbox" name="checkbox" id="checkbox-privacy" />
                                            <label for="checkbox-privacy" class="checkbox-label">
                                                <router-link :to="{name: 'terms'}" target="_blank" class="nounderline">
                                                    <span>Ho preso visione delle condizioni d'uso e le accetto</span>
                                                </router-link>
                                            </label>
                                        </div>
                                        <div class="privacy-box">
                                            <b-form-checkbox v-model="gdpr" ref="checkbox-gdpr" required type="checkbox" name="checkbox" id="checkbox-gdpr" />
                                            <label for="checkbox-gdpr" class="checkbox-label">
                                                <p>
                                                    <a :href="site.urlPrivacy" target="_blank">Ho preso visione delle condizioni di trattamento dei dati e le accetto</a>
                                                </p>
                                            </label>
                                        </div>
                                        <div class="privacy-box" v-if="disclaimerCheckout.copy !== ''">
                                          <b-form-checkbox v-model="disclaimerCheckout.value" ref="disclaimerCheckout" required type="checkbox" name="checkbox" id="disclaimerCheckout" />
                                          <label for="disclaimerCheckout" class="checkbox-label">
                                            <p v-html="disclaimerCheckout.copy"></p>
                                          </label>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="sidebar-checkout--submit">
                                    <b-spinner v-if="loading" variant="primary" />
                                    <b-button v-else variant="success" :disabled="!can_submit" @click="check_pax_or_purchase">Conferma</b-button>
                                    <b-modal id="info-pax-modal" title="Inserisci i dati dei partecipanti" size="xl" hide-footer>
                                        <info-pax
                                            @completed="(pax) => { this.update_pax_and_proceed_to_checkout(pax) }"
                                            :occupancy="(travel.quote.details.occupancy ? travel.quote.details.occupancy : {})"
                                            :title="'Sei ad un passo dalla Prenotazione del tuo viaggio!'"
                                            :text_top="'Inserisci i dati esattamente come riportati nel documento che utilizzerai per il check-in in hotel o in aeroporto.'"
                                            :text_down="'Cliccando sul tasto Prenota ora! il costo del viaggio verrà addebitato sul tuo conto welfare e procederemo alla conferma definitiva dei servizi richiesti.'"
                                            :text_cta="'Prenota ora!'"
                                        />
                                    </b-modal>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { checkout } from '@/api'
    import { validate_fields } from '@/validate'
    import DetailOvernight from '@/components/detail/detail-overnight'
    import DetailFlight from '@/components/detail/detail-flight'
    import InfoPax from '@/components/blocks/info-pax'
    import { custom_event } from '@/utilities'
    import DetailPackage from '@/components/detail/detail-package'

    export default {
        name: 'checkout',
        components: {
            'detail-overnight': DetailOvernight,
            'detail-flight': DetailFlight,
            'info-pax': InfoPax,
            'detail-package': DetailPackage,
        },
        props:
        {
        },
        data() {
            return {
                loading: false,
                can_submit: false,
                submitted: false,
                submitted_confirm_code: '',//api: "confirmcode"
                submitted_msg: '',//api: "msg"
                submitted_travel_voucher_id: '',//api: "travelVoucherId"
                submitted_redirect_to: '',//api: "redirectTo"
                submitted_update_availability_to: 0,//api: "updateAvailabilityTo"
                travel: this.$store.state.travel,
                integration: Vue.prototype.$config.integration,
                site: Vue.prototype.$config.site,
                firstname: '',
                lastname: '',
                phone: '',
                email: '',
                email_confirm: '',
                gdpr: false,
                privacy: false,
                disclaimerCheckout: {
                  value: false,
                  copy: Vue.prototype.$config.guiSettings.disclaimerCheckout
                },
                pax: {},
            }
        },
        computed: {
        },
        created()
        {
            this.validate_fields = validate_fields
        },
        mounted() {

          custom_event('initiateCheckout', this.travel.productCode)

        },
        methods:{
            validate()
            {
                if(Object.keys(this.$refs).length == 0) return false

                let validation_fields = [
                    {
                        ref: this.$refs['request-customer-firstname'],
                        type: 'firstname',
                        value: this.firstname,
                        optional: false,
                    },
                    {
                        ref: this.$refs['request-customer-lastname'],
                        type: 'lastname',
                        value: this.lastname,
                        optional: false,
                    },
                    {
                        ref: this.$refs['request-customer-email'],
                        type: 'emailtobeconfirmed',
                        value: this.email,
                        optional: false,
                    },
                    {
                        ref: this.$refs['request-customer-email-confirm'],
                        type: 'emailconfirm',
                        value: this.email_confirm,
                        optional: false,
                        email: this.email
                    },
                    {
                        ref: this.$refs['request-customer-phone'],
                        type: 'phone',
                        value: this.phone,
                        optional: false,
                    },
                    {
                        ref: this.$refs['checkbox-privacy'],
                        type: 'checkbox',
                        value: this.privacy,
                        optional: false,
                    },
                    {
                        ref: this.$refs['checkbox-gdpr'],
                        type: 'checkbox',
                        value: this.gdpr,
                        optional: false,
                    },
                ]

                if (this.$refs['disclaimerCheckout']) {
                  validation_fields.push({
                    ref: this.$refs['disclaimerCheckout'],
                    type: 'checkbox',
                    value: this.disclaimerCheckout.value,
                    optional: false,
                  })
                }

                let validation = validate_fields(validation_fields)

                this.can_submit = validation
                return validation
            },
            update_pax_and_proceed_to_checkout(pax)
            {
                this.pax = pax
                this.$bvModal.hide('info-pax-modal')
                this.purchase()
            },
            check_pax_or_purchase()
            {
                this.log('check_pax_or_purchase')
                // i pax vanno chiesti sempre
                this.$bvModal.show('info-pax-modal')
                /*
                // se c'è almeno un volo apro la modal
                if(this.travel.quote.services.filter(function(s){ return s.type == 'flight' }).length !== 0)
                {
                    this.$bvModal.show('info-pax-modal')
                }
                // se non ci sono voli procedo all'acquisto
                else
                {
                    this.purchase()
                }
                */
            },
            purchase()
            {
                this.loading = true
                let _this = this
                setTimeout(function(){
                    let payload = {
                        // beneficiario
                        guestFirstName: _this.firstname,
                        guestLastName: _this.lastname,
                        guestEmail: _this.email,
                        guestEmailConf: _this.email_confirm,
                        guestPhone: _this.phone,
                        guestPrivacy: _this.privacy,
                        guestGdpr: _this.gdpr, // non mappato lato be
                        bookingData: {
                            travelId: _this.travel.travelId,
                            quoteHash: _this.travel.quoteHash,
                            payments: {
                                welfare: {
                                amount: _this.travel.public_price,
                                },
                            },
                            pax: _this.pax,
                        },

                    }
                    checkout(payload)
                        .then(
                            (success) => {
                                _this.submitted_confirm_code = success.data.confirmcode
                                _this.submitted_msg = success.data.msg
                                _this.submitted_travel_voucher_id = success.data.travelVoucherId
                                _this.submitted_redirect_to = success.data.redirectTo
                                _this.submitted_update_availability_to = success.data.updateAvailabilityTo
                                _this.submitted = true
                                _this.loading = false
                                _this.$router.push({
                                    name: 'confirm',
                                    params: {
                                        travel_voucher_id: success.data.travelVoucherId,
                                        confirm_code: success.data.confirmcode
                                    }
                                })

                                custom_event('confirmedCheckout', success.data.productCode)
                                if(success.data.boughtProductTypes){
                                  success.data.boughtProductTypes.forEach(productType => {
                                    custom_event('bought_' + productType)
                                  })
                                }
                            },

                            (error) => {
                              (error)
                              _this.loading = false
                              custom_event('checkoutError')
                            },
                        )

                }, 500)
            },


        }, // methods
    }
</script>

<style lang="scss">
.checkout
{
    margin-bottom:80px;
    .sidebar-checkout
    {
        margin-bottom:80px;
        .panel
        {
            margin-bottom:1rem;
        }
        .privacy-box
        {
            display:flex;
            //&:not(:last-child)
            //{
                padding-top:1rem;
            //}
            .checkbox-label
            {
                display:inline-block;
            }
            p,label
            {
                margin:0;
            }
        }
        &--block
        {
            &:not(:last-child)
            {
                margin-bottom:1rem;
            }
        }
        &--title
        {
            font-weight:bold;
            display: block;
            text-align: center;
            font-size: 20px;
            margin-bottom:1rem;
        }
        &--header
        {
            @extend .sidebar-checkout--block;
            display:flex;
            align-items: center;
            flex-wrap: wrap;
            &--name
            {
                flex:1;
                padding: 0 1rem;
                font-weight:bold;
            }
            &--availability
            {
                font-weight: bold;
                color:$primary;
            }
            &--avatar
            {
                width:60px;
                img
                {
                    max-width: 100%;
                    height:auto;
                }
            }
        }
        &--resume
        {
            @extend .sidebar-checkout--block;
            &--total
            {
                color:$green;
                text-align: right;
                font-weight: bold;
                margin-top:1rem;
            }
        }
        &--fields
        {
            @extend .sidebar-checkout--block;
        }
        &--submit
        {
            @extend .sidebar-checkout--block;
            text-align: center;
            margin-top:2rem;
            .btn
            {
                display: block;
                width:100%;
            }
        }
    }

    &--sent
    {
        background-color:$primary;
        color:$white;
        padding:$grid-gutter-width/2 $grid-gutter-width;
        &--title
        {
            font-size: 28px;
            font-weight: 600;
            max-width: 75%;
            margin-bottom:$grid-gutter-width/4;
        }
        &--subtitle
        {
            font-size: 14px;
            font-weight: 400;
            max-width: 50%;
            margin-bottom:$grid-gutter-width/2;
        }
    }    
}
</style>